import { getCourseInstancePath } from 'components/dashboard/ClassCard/helpers'
import {
  getClassCardDisplayData,
  getClassInstanceId,
  getClassTier,
  getClassTitle,
} from 'components/ProductLessons/classListHelpers'
import { selectLessonsCurriculumClasses } from 'pages/LessonsCurriculum/data'
import { DIGITAL_WELL_BEING_PRODUCT_NAME } from 'pages/LessonsCurriculum/constants'
import { coursesWithNewContentfulIds, getCourseLinks } from 'utils/lmsHelpers'
import { programKeyMap } from 'utils/program/types'
import { extractClassIdFromSearch } from 'utils/routing/urlHelpers'

// Curriculum-service program hrefs are the Learn program keys, e.g. /middle-school.
export const getProgramKeyFromNavigation = navigation =>
  String(navigation?.program?.href || '').replace(/^\/+|\/+$/g, '') || null

// Matches where the class card on the Lessons page sends the user.
const getClassRoute = ({ classItem, courseLinks, programKey, tier }) => {
  const instance = getClassInstanceId(classItem)
  const displayData = getClassCardDisplayData({
    classItem,
    courseLinks,
    tier,
    program: programKey,
  })
  const { defaultUnit, gradeDisplayTitle, gradeSlug } = displayData

  if (programKey === DIGITAL_WELL_BEING_PRODUCT_NAME && tier === 1) {
    return `/product/${programKey}/lessons/teach/${gradeSlug}?class=${instance}`
  }

  return getCourseInstancePath({
    program: programKey,
    gradeDisplayTitle,
    instance,
    tier,
    defaultUnit: tier === 2 ? defaultUnit : undefined,
  })
}

const isTeachPath = ({ pathname, programKey }) =>
  pathname.startsWith(`/product/${programKey}/lessons/`) &&
  pathname.includes('/teach/')

/**
 * Dropdown links for the user's classes in the current program and site, or
 * null while instructor data has not loaded yet.
 * @param {Object} params
 * @param {Object} params.instructorData - lmsManager instructor data
 * @param {Object} params.userContext - userContextManager state (active sites)
 * @param {string} params.programKey - Learn program key, e.g. 'middle-school'
 * @param {string} [params.pathname=''] - current pathname
 * @param {string} [params.search=''] - current query string
 */
export const getClassNavLinks = ({
  instructorData,
  userContext,
  programKey,
  pathname = '',
  search = '',
}) => {
  if (!instructorData || !programKey) return null

  const classes = selectLessonsCurriculumClasses({
    instructorData,
    userContext,
    programKey,
  })
  if (classes.length === 0) return []

  const courseLinks = getCourseLinks(
    coursesWithNewContentfulIds({ programType: programKeyMap[programKey] }),
  )
  const currentClassId = isTeachPath({ pathname, programKey })
    ? extractClassIdFromSearch(search)
    : null

  return classes.map(classItem => {
    const tier = getClassTier(classItem)
    const instance = getClassInstanceId(classItem)

    return {
      tier,
      title: getClassTitle(classItem),
      route: getClassRoute({ classItem, courseLinks, programKey, tier }),
      isSelected: !!currentClassId && currentClassId === instance,
    }
  })
}
